import filesApiFactory from '@/api/files.api';
const API = filesApiFactory('blobs/images');


const state = {
  uploadedImage: undefined,

};

const getters = {
  uploadedImage: (state) => state.uploadedImage,
};

const mutations = {
  setUploadedImage: (state, uploadedImage) => {
    state.uploadedImage = uploadedImage;
  },
};

const actions = {
  async uploadImage({commit}, data) {
    const response = await API.upload(data);
    if (response.data) {
      commit('setUploadedImage', response.data);
      return response.data;
    }
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
